export default {
  /* 加工模块 */
  createProcessing: { // 新增加工过程
    url: '/api/createProcessing',
    method: 'post'
  },
  updateProcessing: { // 修改加工过程
    url: '/api/updateProcessing',
    method: 'put'
  },
  deleteProcessing: { // 删除工艺
    url: '/api/deleteProcessing',
    method: 'delete'
  },
  deleteProcessingProcess: { // 删除工序
    url: '/api/deleteProcessingProcess',
    method: 'delete'
  },
  getProcessing: { // 查询加工过程
    url: '/api/getProcessing',
    method: 'get'
  },
  /* 包装模块 */
  createPackingManagement: { // 新增包装
    url: '/api/createPackingManagement',
    method: 'post'
  },
  updatePackingManagement: { // 修改包装
    url: '/api/updatePackingManagement',
    method: 'put'
  },
  getPackingManagement: { // 查询包装
    url: '/api/getPackingManagement',
    method: 'get'
  },
  deletePackingManagement: { // 删除包装
    url: '/api/deletePackingManagement',
    method: 'delete'
  },
  getPackingTraceByTraceCode: { // 根据追溯码查询
    url: '/api/getPackingTraceByTraceCode',
    method: 'get'
  },
  /* 检测报告模块 */
  createTestReport: { // 新增检测报告
    url: '/api/createTestReport',
    method: 'post'
  },
  updateTestReport: { // 修改检测报告
    url: '/api/updateTestReport',
    method: 'put'
  },
  savePackingTrace: { // 保存追溯信息
    url: '/api/savePackingTrace',
    method: 'post'
  },
  deleteTestReport: { // 删除检测报告
    url: '/api/deleteTestReport',
    method: 'delete'
  }
}
